import { render, staticRenderFns } from "./VariantProduct.vue?vue&type=template&id=2f1e9e80&scoped=true"
import script from "./VariantProduct.vue?vue&type=script&lang=js"
export * from "./VariantProduct.vue?vue&type=script&lang=js"
import style0 from "./VariantProduct.vue?vue&type=style&index=0&id=2f1e9e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e9e80",
  null
  
)

export default component.exports